import FileViewer from './views/FileViewer';

export const commonRoutes = [
  {
    path: '/file-viewer',
    component: FileViewer,
    name: 'FileViewer'
  }
]